import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { SrIcon, type SrIconName } from "@/components/ui/SrIcon";
import { SALES_SCREEN_PATH } from "@/lib/sales-display-preview";

interface ScreenLink {
  to: string;
  icon: SrIconName;
  color: string;
  title: string;
  description: string;
}

const SCREENS: ScreenLink[] = [
  {
    to: "/display/produksjon",
    icon: "monitor",
    color: "bg-primary/10 text-primary",
    title: "Produksjon Dashboard",
    description: "Timer, faktureringsrate, prosjektstatus og konsulent-toppliste",
  },
  {
    // Skjermruta, ikke /display/salg: den siste viser appens meny rundt
    // skjermbildet. /display/salg finnes fortsatt for den som vil kikke
    // inne i appen.
    to: SALES_SCREEN_PATH,
    icon: "chart-no-axes-combined",
    color: "bg-blue-500/10 text-blue-700",
    title: "Salgsdisplay",
    description: "Slide-loop med årsmål, månedssalg, selgere og hendelser. Fullskjerm, uten meny.",
  },
  {
    to: "/display/kantine",
    icon: "utensils-crossed",
    color: "bg-emerald-500/10 text-emerald-600",
    title: "Kantineskjerm",
    description: "Meldinger fra ledelsen, hendelser og bursdager med bakgrunnsvideo",
  },
];

export default function DisplayPage() {
  return (
    <div className="page-container animate-fade-in space-y-6">
      <h1 className="font-display font-semibold text-[clamp(28px,3vw,40px)] tracking-[-0.01em] flex items-center gap-2 mb-6">
        <SrIcon name="tv" className="h-6 w-6"  />
        Display-skjermer
      </h1>

      <Card>
        <CardContent className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {SCREENS.map((s) => (
              <Link key={s.to} to={s.to}>
                <div className="p-6 rounded-lg border border-border/50 bg-card/50 hover:bg-accent/50 transition-colors cursor-pointer text-center">
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center mx-auto mb-3 ${s.color}`}>
                    <SrIcon name={s.icon} className="w-6 h-6" />
                  </div>
                  <h3 className="font-medium">{s.title}</h3>
                  <p className="text-sm text-muted-foreground mt-1">{s.description}</p>
                </div>
              </Link>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
